import { useState } from "react";
import { MdCloudUpload } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import TermsAndCondition from "../suspense/TermsAndCondition";

const Footer = () => {
  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handlePublish = () => {
    if (token) {
      navigate("/add-new-project");
    } else {
      navigate("/login");
    }
  };

  const navigateToMagazine = () => {
    if (token) {
      if (role === "SUPER_ADMIN") {
        navigate("/magzine");
      } else {
        navigate("/magazines");
      }
    } else {
      navigate("/login");
    }
  };
  return (
    <div className="bg-neutral-900">
      <div className="lg:px-40">
        <div className="flex justify-center">
          <button
            type="button"
            className="flex items-center mt-5 gap-2 text-gray-50 hover:text-blue-400 border border-gray-50 hover:bg-gray-900 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-md px-5 py-2.5 text-center me-2 mb-2 dark:border-gray-600 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-800"
            onClick={handlePublish}
          >
            <MdCloudUpload className="text-lg" /> Publish
          </button>
        </div>
        <footer className="text-white body-font">
          <div className="container  py-10 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col">
            <div className="w-64 flex-shrink-0 md:mx-0 mx-auto text-center md:text-left">
              <Link
                to="/"
                className="flex title-font font-medium items-center md:justify-start justify-center text-white"
              >
                <img src={logo} className="w-32" alt="logo" />
              </Link>
              <p className="mt-2 text-sm text-white">
                Explore Balarch Magazine for innovative architecture, curated designs, and top products shaping the future.
              </p>
            </div>
            <div className="flex-grow flex flex-wrap md:pl-20 -mb-10 md:mt-0 mt-10 md:text-left text-center">
              <div className="lg:w-1/3 md:w-1/2 w-full text-white px-4">
                <h2 className="text-xl font-semibold tracking-widest mb-3">
                  Explore
                </h2>
                <nav className="list-none mb-10 cursor-pointer">
                  <li className="mb-5">
                    <Link to="/projects" className="hover:text-blue-400">
                      Projects
                    </Link>
                  </li>
                  <li className="mb-5">
                    <Link to="/professionals" className="hover:text-blue-400">
                      Professionals
                    </Link>
                  </li>
                  <li className="mb-5">
                    <Link to="/products" className="hover:text-blue-400">
                      Products
                    </Link>
                  </li>
                </nav>
              </div>
              <div className="lg:w-1/3 md:w-1/2 w-full text-white px-4">
                <h2 className="text-xl font-semibold tracking-widest mb-3">
                  Marketing
                </h2>
                <nav className="list-none mb-10 cursor-pointer">
                  <li className="mb-5">
                    <Link to="" className="hover:text-blue-400">
                      About Us
                    </Link>
                  </li>
                  <li className="mb-5">
                    <Link to="/pricing" className="hover:text-blue-400">
                      Subscriptions
                    </Link>
                  </li>
                  <li className="mb-5">
                    <button
                      type="button"
                      onClick={navigateToMagazine}
                      className="hover:text-blue-400 text-left bg-transparent border-0 p-0 cursor-pointer font-normal w-full md:w-auto"
                    >
                      Magazine
                    </button>
                  </li>
                </nav>
              </div>
              <div className="lg:w-1/3 md:w-1/2 w-full text-white px-4">
                <h2 className="text-xl font-semibold tracking-widest mb-3">
                  Support
                </h2>
                <nav className="list-none mb-10 cursor-pointer">
                  <li className="mb-5">
                    <Link to="" className="hover:text-blue-400">
                      FAQs
                    </Link>
                  </li>
                  <li className="mb-5">
                    <button
                      type="button"
                      onClick={() => setIsTermsOpen(true)}
                      className="hover:text-blue-400 text-left bg-transparent border-0 p-0 cursor-pointer font-normal w-full md:w-auto"
                    >
                      Terms of Use
                    </button>
                  </li>
                  <li className="mb-5">
                    <Link to="" className="hover:text-blue-400">
                      Privacy Policy
                    </Link>
                  </li>
                </nav>
              </div>
            </div>
          </div>
          <hr />
          <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
            <p className="text-white text-sm text-center sm:text-left">
            © Balarch, Inc. 2023. | Studio@bal-arch.com
            </p>
            <span className="inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start">
              <a
                href="https://www.facebook.com/profile.php?id=61561676559843"
                target="_blank"
                rel="noreferrer"
                className="text-gray-900 rounded-full bg-gray-300 p-2"
              >
                <svg
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                </svg>
              </a>
              <Link className="ml-3 text-gray-900 rounded-full bg-gray-300 p-2">
                <svg
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
                </svg>
              </Link>
              <Link className="ml-3 text-gray-900 rounded-full bg-gray-300 p-2">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
                </svg>
              </Link>
            </span>
          </div>
        </footer>
        <TermsAndCondition open={isTermsOpen} setOpen={setIsTermsOpen} otpCheck={false} />
      </div>
    </div>
  );
};

export default Footer;
